module.exports = __webpack_public_path__ + "img/credit-notes.9e489310.svg";